import { render } from "./AgentLeads.vue?vue&type=template&id=56f08cac&scoped=true"
import script from "./AgentLeads.vue?vue&type=script&lang=js"
export * from "./AgentLeads.vue?vue&type=script&lang=js"

import "./AgentLeads.vue?vue&type=style&index=0&id=56f08cac&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-56f08cac"

export default script